<template>
    <div class="d-flex flex-sm-column flex-md-row justify-content-between">
        <player
            :topic="selected"
            :config="playerOptions"
            @next="nextVideo"
            :onboarding="onboarding"
        ></player>
        <playlist
            :onboarding="onboarding"
            @selected="selectedVideo"
            :topics="topics"
        ></playlist>
    </div>
</template>

<script>
import Player from './Player.vue';
import Playlist from './Playlist.vue';

export default {

    name: 'stage',

    components: {
        Player,
        Playlist
    },

    props: {
        topics: {
            type: Array,
            default: () => {
                return [];
            }
        },
        playerOptions: {
            width: 720,
            id: 'helpVideo'
        },
        onboarding: false,
        onboardingUrl: null,
    },

    data() {
        return {
            selected: null,
            lastVideo: null,
        }
    },

    mounted () {
        if(this.selected == null) {
            this.selected = this.topics[0]
        }

        this.lastVideo = this.topics.length;
        const myModalEl = document.getElementById('helpVideoModal')
        myModalEl.addEventListener('hidden.bs.modal', event => {
            this.completeOnboarding();
        })
    },

    methods: {
        selectedVideo(topic) {
            this.selected = this.topics[topic]
        },
        nextVideo() {
            let index = this.topics.findIndex((topic) => topic?.id == this.selected?.id);
            if (index == -1) {
                this.completeOnboarding();
                return
            }

            this.selected = this.topics[++index];

            if (index >= this.lastVideo) {
                this.completeOnboarding();
            }
        },
        completeOnboarding() {
            if (!this.onboardingUrl || !this.onboarding) {
                return
            }

            axios.patch(this.onboardingUrl)
                .then(response => {
                })
                .catch(error => {
                    // signal flare of this error
                })
        }
    }
}
</script>
